import polypropylene from "./polypropylene.jsx";
export default polypropylene